import { render, staticRenderFns } from "./agogis-booking-comment.vue?vue&type=template&id=0b866b16"
import script from "./agogis-booking-comment.vue?vue&type=script&lang=ts"
export * from "./agogis-booking-comment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports